<template>
    <div class="users-style">

      <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance Settings<span>
          <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance Settings / Penalty Policy</span>
      </h4>

      <div id="settings" class="mt-4 employee-tab leave-attendance-dashboard">
        <b-tabs pills content-class="custom-tab-content" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white" nav-class="mb-4 mt-3 leave-attendance-dashboard-tab">
          <b-tab v-on:click="successmsg = ''">
            <template v-slot:title>
                <img v-bind:src="$api_url+'/images/cf-fixed-benefits.png'"  class="img-fluid mr-2" height="30px" width="30px" />Penalty Policy
            </template>
            <div class="">
              <div class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0 pt-0 pb-0 roster-ibox">
                <h4 class="clearfix mb-0 mt-3">
                  <span class="float-left">Penalty Policy
                      <span class="title-sub-text"></span>
                  </span>
                  <span class="float-right"></span>
                </h4>
              </div>
              <div class="d-flex bd-highlight py-2 mb-2">
                <div class="custom-search w-100">
                  <b-input-group class="mb-0">
                    <b-input-group-prepend is-text>
                      <b-icon icon="search"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input type="search" placeholder="Search.." v-model="search"
                                  @input="resetPagination()"></b-form-input>
                  </b-input-group>
                </div>

                <div class="ml-auto">
                  <b-button id="show-btn" @click="addNew()"> + Create Penalty Policy</b-button>
                </div>
              </div>

                <table class="table dataTable">
                  <thead>
                    <tr class="table-head">
                      <template v-for="column in columns">
                        <th><span>{{ column.label }}</span></th>
                      </template>
                      <th class="text-right">Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr class="hover-bg table-row mx-2" v-for="item in filteredData" :key="item.id">
                      <td>{{ item.name }}</td>
                      <td>{{ item.types }}</td>
                      <td class="text-right position-relative">
                        <a :id="'actionDropdown-' + item.id" class="dropdown-toggle clearfix action-dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <b-icon icon="three-dots-vertical"></b-icon>
                        </a>
                        <div class="dropdown-menu action-dropdown-menu" :aria-labelledby="'actionDropdown-' + item.id">
                          <b-button-group>
                            <b-button variant="outline-secondary" @click="editData(item.id)">
                              <b-icon icon="pencil"></b-icon>Edit
                            </b-button>
                            <b-button variant="outline-secondary" @click="deleteData(item.id)">
                              <b-icon icon="trash-fill"></b-icon>Delete
                            </b-button>
                          </b-button-group>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                <div v-else class="px-3">
                  <ul class="pagination b-pagination float-left mb-0 mt-1">
                    <li class="page-item disabled m-2">View</li>
                    <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                    <li class="page-item disabled m-2">per page. Total {{datalist.length}} records found.</li>
                  </ul>
                  <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>

                </div>
              </div>
          </b-tab>
          <b-tab v-on:click="successmsg = ''">
            <template v-slot:title>
                <img v-bind:src="$api_url+'/images/cf-fixed-benefits.png'"  class="img-fluid mr-2" height="30px" width="30px" />Policy Log
            </template>

            <div class="">

              <div class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0 pt-0 pb-0 roster-ibox">
                <h4 class="clearfix mb-0">
                  <span class="float-left">Policy Log
                      <span class="title-sub-text"></span>
                  </span>
                  <span class="float-right"></span>
                </h4>
              </div>
              
              <div class="table-responsive">
                <table class="table dataTable">
                  <thead>
                    <tr class="table-head">
                      <th>Policy Name</th>
                      <th>Description</th>
                      <th class="text-right">Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="log in paginatedLogs" :key="log.id" class="hover-bg table-row mx-2">
                      <td>{{ log.policy_name }}</td>
                      <td>{{ log.action }}d By {{ log.activity_by }} at {{ formatDateTime(log.created_at) }}</td>
                      <td class="text-right position-relative">
                        <template v-if="log.details">
                          <a :id="'actionDropdown-log-' + log.id" class="dropdown-toggle clearfix action-dropdown-toggle"
                            href="#" role="button" data-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false">
                            <b-icon icon="three-dots-vertical"></b-icon>
                          </a>
                          <div class="dropdown-menu action-dropdown-menu" :aria-labelledby="'actionDropdown-log-' + log.id">
                            <b-button-group>
                              <b-button variant="outline-secondary" @click="viewLogDetails(log)">
                                <b-icon icon="eye"></b-icon>
                                View details
                              </b-button>
                            </b-button-group>
                          </div>
                        </template>
                        <span v-else class="text-muted small">N/A</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-if="activityLogs.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
              <div v-if="activityLogs.length > 0" class="px-3 mt-3 d-flex justify-content-between align-items-center">
                <ul class="pagination b-pagination mb-0 mt-1">
                  <li class="page-item disabled m-2">View</li>
                  <li class="page-item disabled">
                    <b-form-select v-model="log_temp_length" :options="log_length_options" @change="log_pagination.currentPage = 1"></b-form-select>
                  </li>
                  <li class="page-item disabled m-2">per page. Total {{activityLogs.length}} logs found.</li>
                </ul>
                <b-pagination
                  v-model="log_pagination.currentPage"
                  :total-rows="activityLogs.length"
                  :per-page="log_temp_length"
                  prev-text="Previous"
                  next-text="Next"
                  first-number
                  last-number
                  class="mb-0 mt-1"
                ></b-pagination>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>

      <!-- Log Details Modal -->
      <b-modal id="bv-modal-log-details" hide-footer title="Policy Log Details" size="lg">
        <div v-if="selectedLog" class="p-3">
          <div class="row mb-3 pb-2 border-bottom">
            <div class="col-sm-4"><strong>Policy Name:</strong></div>
            <div class="col-sm-8">{{ selectedLog.policy_name }}</div>
          </div>
          <div class="row mb-3 pb-2 border-bottom">
            <div class="col-sm-4"><strong>Description:</strong></div>
            <div class="col-sm-8">{{ selectedLog.action }}d By {{ selectedLog.activity_by }} at {{ formatDateTime(selectedLog.created_at) }}</div>
          </div>
          
          <div v-if="parsedDetails" class="mt-4">
            <h5 class="font-weight-bold mb-3">Configured Rules:</h5>
            <div v-for="(rule, type) in parsedDetails" :key="type" class="ibox p-3 mb-3">
              <h6 class="font-weight-bold text-primary pb-2">{{ getTypeText(type) }}</h6>
              <div class="row mt-2">
                <div class="col-md-6 mb-2">
                  <strong>Status:</strong> 
                  <span :class="rule.status == 1 ? 'text-success' : 'text-danger'">
                    {{ rule.status == 1 ? 'Active' : 'Inactive' }}
                  </span>
                </div>
                <div class="col-md-6 mb-2">
                  <strong>Deduction Basis:</strong> {{ rule.deduct_from == 1 ? 'Salary' : 'Leave' }}
                </div>
                
                <template v-if="rule.deduct_from == 0">
                  <div class="col-12 mb-2" v-if="rule.leave_deduction_layers && rule.leave_deduction_layers.length > 0">
                    <strong>Leave Layers:</strong> {{ getLeaveLayerNamesForLog(rule.leave_deduction_layers) }}
                  </div>
                </template>
                
                <template v-if="rule.salary_deduction_enabled == 1">
                  <div class="col-md-6 mb-2">
                    <strong>Salary Deduction:</strong> {{ rule.salary_percentage }}% of {{ rule.salary_depends_on == 1 ? 'Gross' : 'Basic' }}
                  </div>
                </template>

                <!-- For Incomplete Hours (type 3) specific configs -->
                <template v-if="type == 3">
                  <div class="col-md-6 mb-2"><strong>Hours Limit:</strong> {{ rule.frequency }} Hrs</div>
                  <div class="col-md-6 mb-2"><strong>Grace Limit:</strong> {{ rule.grace }} Hrs</div>
                  <div class="col-md-6 mb-2"><strong>Deduction:</strong> {{ rule.leave_deduct }} Days</div>
                </template>
              </div>

              <div v-if="rule.conversion_rules && rule.conversion_rules.length > 0 && type != 3" class="mt-2">
                <strong>Conversion Rules:</strong>
                <table class="table dataTable border">
                  <thead class="table-head">
                    <tr>
                      <th>Ratio</th>
                      <th>Deduction Days</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(crule, cidx) in rule.conversion_rules" :key="cidx">
                      <td>{{ crule.days }} {{ getConversionDaysLabelText(type) }}</td>
                      <td>{{ crule.deduct }} days</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </b-modal>


        <b-modal id="bv-modal-penalty-policy" size="xl" hide-footer scrollable :title="modalTitle">
            <b-form @submit.stop.prevent="onSubmit">

              <b-form-group label="Penalty Policy Name" label-for="policy_name" class="required-field">
                <b-form-input
                    id="policy_name"
                    name="policy_name"
                    v-model="fdata.name"
                    placeholder="Enter policy name"
                    v-validate="{ required: true, min: 3, regex: /^[A-Za-z0-9&()\/,_.\- ]+$/ }"
                    :state="validateState('policy_name')"
                    aria-describedby="policy_name_feedback"
                    data-vv-as="Policy Name"
                ></b-form-input>
                <b-form-invalid-feedback id="policy_name_feedback" class="d-block">
                  {{ veeErrors.first('policy_name') }}
                </b-form-invalid-feedback>
              </b-form-group>

            <!-- // Mustafijur: start  -->
            <div class="p-3 rounded">

                <div class="approve-level-content p-0 pb-2 text-center form-group d-flex flex-column">
                    <span class="salary-heads text-muted">Add Penalty Rule Type</span>
                    <label class="text-muted">Activate/deactivate a Penalty Rule Type to set up your desired penalty policy.</label>
                </div>
                <div>
                    <b-form-group label="" class="leave-attendance-legends col-12 px-0">
                        <b-form-radio-group :key="tabRadioKey" class="leave-attendance-btns w-100" :checked="selected_type" @change="changeTab" buttons button-variant="outline-secondary">
                            <b-form-radio v-for="type in types" :key="type.value" :value="type.value">
                                <span>{{ type.text }}</span>
                                <b-icon v-if="fdata.policies[type.value] && fdata.policies[type.value].status == 1" class=" ml-3 position-absolute" icon="check-circle-fill" variant="success" style="top: 8px; right: 10px;"></b-icon>
                            </b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </div>

                <div class="mb-3">
                    <div class="d-flex flex-row justify-content-between align-items-center py-2 px-3 rounded bg-wash approve-level-content">
                        <span class="roster-toggle-label salary-heads">
                            Enable "{{ getTypeText(selected_type) }}" Penalty
                            <b-icon icon="info-circle" v-b-tooltip.hover.top="'When enabled, this penalty type is saved with the policy. When disabled, it is excluded.'"></b-icon>
                        </span>
                        <div class="d-flex flex-row align-items-center">
                            <label class="mr-2 mb-0 roster-toggle-label" >
                                Inactive
                            </label>
                            <b-form-checkbox class="roster-small-switch" switch v-model.number="fdata.policies[selected_type].status" :value="1" :unchecked-value="0" />
                            <label class="ml-1 mb-0 roster-toggle-label">
                                Active
                            </label>
                        </div>
                    </div>
                </div>

                <!-- Only render the panel for the currently selected type -->
                <div v-for="i in tabs" :key="'dyn-tab-' + i">
                    <template v-if="i == selected_type">

                    <!-- Config is only editable when this type is enabled -->
                    <template v-if="fdata.policies[i].status == 1">

                    <template v-if="selected_type != 3" >
                        <b-form-row class="ml-0">

                            <b-col cols="8" class="px-0">
                                <div class="bg-wash p-3 rounded">

                                    <b-form-group id="conversion-rules-group" class="mb-0">
                                        <template #label>
                                            <div class="row pb-2">
                                                <div class="col-12">
                                                    <div class="approve-level-content p-0 mb-2 text-left form-group d-flex flex-column border-bottom">
                                                        <span class="roster-toggle-label salary-heads">
                                                            Conversion Rules <b-icon icon="info-circle" v-b-tooltip.hover.top="'Define conversion rules. You can add multiple conversion rules.'"></b-icon>
                                                        </span>
                                                        <label class="roster-font-weight-regular">Define conversion rules. You can add multiple conversion rules.</label>
                                                    </div>
                                                </div>
                                                <div class="col-12 approve-level-content p-0 px-3" id="penalty_factor">
                                                    <div class="toggle_button_tax d-flex justify-content-between align-items-center border-bottom pb-2 salary-heads">
                                                        <div class="roster-toggle-label cmp-child-items">Factor Rule</div>
                                                        <div class="trz_tax_button px-0 tax_toggle">
                                                            <label data-v-25adc6c0="" class="vue-js-switch toggled mb-0">
                                                                <input type="radio" v-model.number="fdata.policies[i].factor" @change="handleFactorChange(i)"
                                                                    class="v-switch-input trz_tax_radio d-none" :name="'factor_rule_' + i" :value="1"/>
                                                                <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px;  background-color: #CC5057;  border-radius: 11px;">
                                                                <div data-v-25adc6c0="" class="v-switch-button"></div></div>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div class="toggle_button_tax d-flex justify-content-between align-items-center border-bottom pb-2 pt-2 salary-heads">

                                                        <div class="roster-toggle-label cmp-child-items">Fixed Rule</div>
                                                        <div class="trz_tax_button px-0 tax_toggle">
                                                            <label data-v-25adc6c0="" class="vue-js-switch toggled mb-0">
                                                            <input type="radio" v-model.number="fdata.policies[i].factor" @change="handleFactorChange(i)"
                                                                class="v-switch-input trz_tax_radio d-none" :name="'factor_rule_' + i" :value="0"/>
                                                            <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px;  background-color: #CC5057;  border-radius: 11px;">
                                                            <div data-v-25adc6c0="" class="v-switch-button" ></div>
                                                            </div> <!----></label>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </template>

                                        <table class="table dataTable" v-if="fdata.policies[i].conversion_rules.length > 0">
                                            <thead>
                                                <tr class="table-head">
                                                    <th>SL.</th>
                                                    <th>{{ conversionDaysLabel }}</th>
                                                    <th>Deduction Days</th>
                                                    <th class="text-center" v-if="fdata.policies[i].factor == 0">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="hover-bg table-row mx-2" v-for="(rule, idx) in fdata.policies[i].conversion_rules" :key="idx">
                                                    <td class="text-center">{{ idx + 1 }}</td>
                                                    <td>
                                                        <b-form-input v-model="rule.days" v-validate="'required|min_value:1'" :name="'days_' + idx" :data-vv-as="conversionDaysLabel"
                                                                    :placeholder="conversionDaysLabel"></b-form-input>
                                                        <small class="text-danger">{{ veeErrors.first('days_' + idx) }}</small>
                                                    </td>

                                                    <td>
                                                        <b-form-input v-model="rule.deduct" v-validate="'required|min_value:0.5'" :name="'deduct_' + idx" data-vv-as="Deduction Days"
                                                            placeholder="Deduction Days"></b-form-input>
                                                        <small class="text-danger">{{ veeErrors.first('deduct_' + idx) }}</small>
                                                    </td>
                                                    <td class="text-center" v-if="fdata.policies[i].factor == 0">
                                                        <b-button variant="outline-danger" size="sm" class="rounded" @click="removeConversionRule(i, idx)" :disabled="fdata.policies[i].conversion_rules.length == 1">
                                                            <b-icon icon="trash"></b-icon>
                                                        </b-button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="full-width text-right">
                                            <label class="mr-2 roster-font-weight-regular">
                                                <strong>{{ fdata.policies[i].conversion_rules.length }}</strong> Rule(s) added
                                            </label>
                                            <b-button variant="primary" class="mb-2 custom-wizard-btn" @click="addConversionRule(i)" v-if="fdata.policies[i].factor == 0">+ Add Rule</b-button>
                                        </div>

                                    </b-form-group>
                                </div>

                                <div class="bg-wash p-3 rounded mt-3">
                                    <!-- Leave Deduction Layers Section -->
                                    <b-form-group id="leave-layers-group" class="mb-0">

                                        <div class="approve-level-content p-0 mb-2 text-left form-group d-flex flex-column border-bottom">
                                            <span class="roster-toggle-label salary-heads">
                                                Leave Deduction Layers <b-icon icon="info-circle" v-b-tooltip.hover.top="'System will automatically move to the next layer when the previous layer balance is exhausted.'"></b-icon>
                                            </span>
                                            <label class="roster-font-weight-regular">System will automatically move to the next layer when the previous layer balance is exhausted.</label>
                                        </div>


                                        <!-- Mustafijur  -->
                                        <table class="table dataTable" v-if="fdata.policies[i].leave_deduction_layers.length > 0">
                                            <thead>
                                                <tr class="table-head">
                                                    <th>Layer</th>
                                                    <th>Leave Category</th>
                                                    <th class="text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="hover-bg table-row mx-2" v-for="(layer, idx) in fdata.policies[i].leave_deduction_layers" :key="'layer-'+idx">
                                                    <td class="text-center">{{ idx + 1 }}</td>
                                                    <td>
                                                        <b-form-select :id="'leave_layer_'+idx" v-model="fdata.policies[i].leave_deduction_layers[idx]" :options="availableLeaveTypes(i, idx)"></b-form-select>
                                                    </td>
                                                    <td class="text-center">
                                                        <b-button variant="outline-danger" size="sm" class="rounded" @click="removeLeaveLayer(i, idx)">
                                                            <b-icon icon="trash"></b-icon>
                                                        </b-button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <!-- Mustafijur   -->
                                        <div class="full-width text-right">
                                            <label class="mr-2 roster-font-weight-regular">
                                                <strong>{{ fdata.policies[i].leave_deduction_layers.length }}</strong> Category(s) added
                                            </label>
                                            <b-button variant="primary" class="mb-2 custom-wizard-btn" @click="addLeaveLayer(i)" :disabled="fdata.policies[i].leave_deduction_layers.length >= leavetypes.length">+ Add Leave Category</b-button>
                                        </div>

                                    </b-form-group>

                                </div>

                                <div class="bg-wash p-3 rounded mt-3 approve-level-content p-0">
                                    <!-- Salary Deduction Toggle -->
                                    <b-form-group id="salary-deduction-enabled-group">
                                        <div class="d-flex flex-row justify-content-between align-items-center pt-1 border-bottom pb-0" >
                                            <div class="d-flex flex-column">
                                                <span class="roster-toggle-label salary-heads">Salary Deduction</span>
                                                <label class="roster-font-weight-regular">Enable salary deduction if all leave layers are exhausted.</label>
                                            </div>
                                            <div class="d-flex flex-row align-items-center">
                                                <b-form-checkbox class="roster-small-switch" switch v-model.number="fdata.policies[i].salary_deduction_enabled" :value="1" :unchecked-value="0" />
                                            </div>
                                        </div>
                                    </b-form-group>

                                    <template v-if="fdata.policies[i].salary_deduction_enabled == 1">
                                        <b-form-group id="salary-depends-on-group" label-for="salary_depends_on">
                                            <template #label>
                                                Salary Depends On <b-icon icon="info-circle" v-b-tooltip.hover.top="'Select the salary component for percentage calculation.'"></b-icon>
                                            </template>
                                            <b-input-group class="mb-2">
                                                <b-form-select id="salary_depends_on" name="salary_depends_on" v-model="fdata.policies[i].salary_depends_on" :options="calculate_on_options"></b-form-select>
                                            </b-input-group>
                                        </b-form-group>
                                        <b-form-group id="salary-percentage-group" label-for="salary_percentage">
                                            <template #label>
                                                Percentage (%) <b-icon icon="info-circle" v-b-tooltip.hover.top="'Percentage to deduct from the selected salary basis.'"></b-icon>
                                            </template>
                                            <b-input-group append="%" class="mb-2">
                                                <b-form-input id="salary_percentage" name="salary_percentage" v-model="fdata.policies[i].salary_percentage" v-validate="{decimal: 2, between: [1, 1000]}" type="number" min="1" max="1000" step="0.01" :state="validateState('salary_percentage')" aria-describedby="salary_percentage-feedback" data-vv-as="Salary Percentage"/>
                                            </b-input-group>
                                            <b-form-invalid-feedback id="salary_percentage-feedback" class="d-block">{{ veeErrors.first('salary_percentage') }}</b-form-invalid-feedback>
                                        </b-form-group>
                                    </template>
                                </div>

                                <div class="bg-wash p-3 rounded mt-3 approve-level-content p-0">
                                  <b-form-group id="salary-deduction-enabled-group">
                                      <div class="d-flex flex-row justify-content-between align-items-center pt-1 border-bottom pb-0">
                                          <div class="d-flex flex-column">
                                              <span class="roster-toggle-label salary-heads">Calculation Days</span>
                                              <label class="roster-font-weight-regular">Exact days in payrun month.</label>
                                          </div>
                                          <div class="d-flex flex-row align-items-center">
                                              <b-form-checkbox class="roster-small-switch" switch 
                                                  :checked="fdata.policies[i].calculation_days > 0"
                                                  @change="val => fdata.policies[i].calculation_days = val ? 1 : 0"
                                              />
                                          </div>
                                      </div>
                                  </b-form-group>

                                  <template v-if="fdata.policies[i].calculation_days > 0">
                                      <b-form-group id="salary-percentage-group" label-for="calculation_days">
                                          <template #label>
                                              Calculation Days<b-icon icon="info-circle" v-b-tooltip.hover.top="'Percentage to deduct from the selected salary basis.'"></b-icon>
                                          </template>
                                          <b-input-group class="mb-2">
                                              <b-form-input id="calculation_days" name="calculation_days" 
                                                  v-model="fdata.policies[i].calculation_days" 
                                                  v-validate="{decimal: 2, between: [1, 1000]}" 
                                                  type="number" min="1" max="1000" step="0.01" 
                                                  :state="validateState('calculation_days')" 
                                                  aria-describedby="calculation_days-feedback" 
                                                  data-vv-as="Calculation Days"
                                              />
                                          </b-input-group>
                                          <b-form-invalid-feedback id="calculation_days-feedback" class="d-block">{{ veeErrors.first('calculation_days') }}</b-form-invalid-feedback>
                                      </b-form-group>
                                  </template>
                              </div>

                            </b-col>
                            <b-col cols="4" class="pl-3">
                                <div class="rounded p-3 bg-wash">
                                <div class="ibox-title p-0 border-0 mb-2">
                                    <h4 class="m-0">Quick Summary:</h4>
                                </div>
                                <ul class="pl-3 mb-0">
                                    <li v-for="(rule, idx) in fdata.policies[i].conversion_rules" :key="'sum-'+idx">
                                    Conversion ratio: {{ rule.days || '?' }} {{ conversionDaysLabel.toLowerCase() }} = {{ rule.deduct || '?' }} deduction day(s)
                                    </li>
                                    <li v-if="fdata.policies[i].conversion_rules.length == 0">No conversion rules</li>
                                    <li v-if="fdata.policies[i].leave_deduction_layers.length > 0">Leave: Deduct from {{ leaveLayerNames(i) }}</li>
                                    <li v-if="fdata.policies[i].leave_deduction_layers.length == 0">No leave layers</li>
                                    <li v-if="fdata.policies[i].salary_deduction_enabled == 1">Salary Deduction: {{ fdata.policies[i].salary_percentage || 0 }}% from {{ fdata.policies[i].salary_depends_on == 1 ? 'Gross' : 'Basic' }} Salary</li>
                                    <li v-else>Salary Deduction: Off</li>
                                </ul>
                                </div>
                            </b-col>

                        </b-form-row>
                    </template>
                    <template v-else>
                        <b-form-row class="p-3 rounded mx-0 bg-wash">
                            <b-col cols="12">
                                <b-form-group id="type-group" label-for="deduct_from">
                                    <div class="d-flex flex-column mb-3 pb-2 border-bottom text-center">
                                        <span class="roster-toggle-label">Deduction Type <b-icon icon="info-circle" v-b-tooltip.hover.top="'Select whether the deduction comes from salary or from leave balance.'"></b-icon></span>
                                        <label class="roster-font-weight-regular">Select whether the deduction comes from salary or from leave balance.</label>
                                    </div>

                                    <div class="row text-center w-75 mx-auto rounded approval-container">
                                        <div v-for="(option, idx) in deduct_from_options" :key="option.value" class="col-6 py-2" :style="idx == 0 ? 'border-right: 1px solid #8F8F8F;' : ''">
                                            <b-form-radio v-model="fdata.policies[i].deduct_from" name="deduct_from" :value="option.value"
                                                size="lg" class="d-inline-block font-weight-bold text-dark">
                                                {{ option.text }}
                                            </b-form-radio>
                                        </div>
                                    </div>

                                </b-form-group>
                            </b-col>

                            <template v-if="fdata.policies[i].deduct_from == 0">
                                <b-col cols="6">
                                <b-form-group id="leave_type_id-group" label="Leave Category" class="required-field" label-for="leave_type_id">
                                    <b-form-select id="leave_type_id" name="leave_type_id" v-model="fdata.policies[i].leave_type_id" v-validate="{ required: true }" :options="leavetypes" :state="validateState('leave_type_id')" data-vv-as="Leave Category" aria-describedby="leave_type_id-feedback"></b-form-select>
                                    <b-form-invalid-feedback id="leave_type_id-feedback" v-if="veeErrors.has('leave_type_id')">{{ veeErrors.first('leave_type_id') }}</b-form-invalid-feedback>
                                </b-form-group>
                                </b-col>
                            </template>
                            <template v-else-if="fdata.policies[i].deduct_from == 1">
                                <b-col cols="6">
                                <b-form-group id="salary_deduct-group" label-for="salary_deduct">
                                    <template #label>
                                    Salary Type <b-icon icon="info-circle" v-b-tooltip.hover.top="'Select whether the deduction comes from salary or from leave balance.'"></b-icon>
                                    </template>
                                    <b-input-group class="mb-2">
                                    <b-form-select id="salary_deduct" name="salary_deduct" v-model="fdata.policies[i].salary_deduct" v-validate="{  }" :options="calculate_on_options"></b-form-select>
                                    </b-input-group>
                                </b-form-group>
                                </b-col>
                            </template>

                            <b-col cols="6">
                                <b-form-group id="frequency-group" label-for="frequency">
                                <template #label>
                                    Incomplete Hours Limit <b-icon icon="info-circle" v-b-tooltip.top.hover="'Incomplete hours limit that activates the penalty.'"></b-icon>
                                </template>
                                <b-input-group append="Hour(s)" class="mb-2">
                                    <b-form-input id="frequency" name="frequency" v-model="fdata.policies[i].frequency" v-validate="{ required: true, min_value:0}" :state="validateState('frequency')"
                                                aria-describedby="frequency-feedback" data-vv-as="Incomplete Hours Limit"></b-form-input>
                                </b-input-group>
                                <b-form-invalid-feedback id="frequency-feedback" class="d-block">{{ veeErrors.first('frequency') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group id="grace-group" label-for="grace">
                                <template #label>
                                    Grace Limit <b-icon icon="info-circle" v-b-tooltip.top.hover="'Allowed number of grace hours before deductions begin.'"></b-icon>
                                </template>
                                <b-input-group append="Hour(s)" class="mb-2">
                                    <b-form-input id="grace" name="grace" v-model="fdata.policies[i].grace" v-validate="{ required: true, min_value:0 }" :state="validateState('grace')" aria-describedby="grace-feedback" data-vv-as="Grace Limit"></b-form-input>
                                </b-input-group>
                                <b-form-invalid-feedback id="grace-feedback" class="d-block">{{ veeErrors.first('grace') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group id="leave_deduct-group" label-for="leave_deduct">
                                <template #label>
                                    Deduction Days <b-icon icon="info-circle" v-b-tooltip.top.hover="'Enter how many days will be deducted once the penalty is applied.'"></b-icon>
                                </template>
                                <b-input-group append="Day(s)" class="mb-2">
                                    <b-form-input id="leave_deduct" name="leave_deduct" v-model="fdata.policies[i].leave_deduct" v-validate="{ required: true, min_value:0 , max_value:30}" :state="validateState('leave_deduct')"
                                                aria-describedby="leave_deduct-feedback" data-vv-as="Deduction Days"></b-form-input>
                                </b-input-group>
                                <b-form-invalid-feedback id="leave_deduct-feedback" class="d-block">{{ veeErrors.first('leave_deduct') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" v-if="fdata.policies[i].deduct_from == 1">
                                <b-form-group id="incomplete-calculation-days-group">
                                    <div class="d-flex flex-row justify-content-between align-items-center pt-1 border-bottom pb-0">
                                        <div class="d-flex flex-column">
                                            <span class="roster-toggle-label salary-heads">Calculation Days</span>
                                            <label class="roster-font-weight-regular">Exact days in payrun month.</label>
                                        </div>
                                        <div class="d-flex flex-row align-items-center">
                                            <b-form-checkbox class="roster-small-switch" switch
                                                :checked="fdata.policies[i].calculation_days > 0"
                                                @change="val => fdata.policies[i].calculation_days = val ? 1 : 0"
                                            />
                                        </div>
                                    </div>
                                </b-form-group>

                                <b-form-group v-if="fdata.policies[i].calculation_days > 0" label-for="calculation_days">
                                    <template #label>
                                        Calculation Days<b-icon icon="info-circle" v-b-tooltip.hover.top="'Days used to get the per day salary for the deduction.'"></b-icon>
                                    </template>
                                    <b-input-group class="mb-2">
                                        <b-form-input id="calculation_days" name="calculation_days"
                                            v-model="fdata.policies[i].calculation_days"
                                            v-validate="{decimal: 2, between: [1, 1000]}"
                                            type="number" min="1" max="1000" step="0.01"
                                            :state="validateState('calculation_days')"
                                            aria-describedby="calculation_days-feedback"
                                            data-vv-as="Calculation Days"
                                        />
                                    </b-input-group>
                                    <b-form-invalid-feedback id="calculation_days-feedback" class="d-block">{{ veeErrors.first('calculation_days') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                    </template>

                    </template>
                    <template v-else>
                        <div class="text-muted text-center py-4">
                        This penalty type is disabled. Enable it above to configure its rules.
                        </div>
                    </template>

                    </template>
                </div>
            </div>
            <div class="full-width mt-2 text-center pb-5">
                <b-button v-if="fdata.id == ''" type="submit" class="">Create</b-button>
                <b-button v-else type="submit" class="">Update</b-button>
                <b-button class="ml-2 custom-wizard-btn" @click="resetForm()">Reset</b-button>
            </div>


            </b-form>
        </b-modal>
    </div>
</template>

<script>
export default {

    props: [],
    data() {
      let sortOrders = {};
      let columns = [
        { label: 'Policy Name', name: 'name', sort: true },
        { label: 'Penalty Type(s)', name: 'types', sort: true },
      ];

      columns.forEach((column) => {
        sortOrders[column.name] = -1;
      });

      return {
        loading: false,
        blankmsg: 'Fetching data..',
        datalist: [],
        showoverlay: false,

        tabs: [0,1,2,3],
        tabCounter: 0,
        activeTab: 0,
        temp_length: 20,
        length_options:
            [
                { value: 20, text: "20" },
                { value: 50, text: "50" },
                { value: 100, text: "100" }
            ],

        fdata: {
          id: '',
          name: '',
          policies: {
            0: {
              type: "0",
              status: 0,
              factor: 0,
              salary_deduction_enabled: 0,
              salary_depends_on: "0",
              salary_percentage: null,
              calculation_days: 0,
              deduct_from: "0",
              leave_type_id: null,
              salary_deduct: "0",
              frequency: null,
              grace: null,
              leave_deduct: null,
              conversion_rules: [
                {
                  days: '',
                  deduct: ''
                }
              ],
              leave_deduction_layers: []
            },
            1: {
              type: "1",
              status: 0,
              factor: 0,
              salary_deduction_enabled: 0,
              salary_depends_on: "0",
              salary_percentage: null,
              calculation_days: 0,
              deduct_from: "0",
              leave_type_id: null,
              salary_deduct: "0",
              frequency: null,
              grace: null,
              leave_deduct: null,
              conversion_rules: [
                {
                  days: '',
                  deduct: ''
                }
              ],
              leave_deduction_layers: []
            },
            2: {
              type: "2",
              status: 0,
              factor: 0,
              salary_deduction_enabled: 0,
              salary_depends_on: "0",
              salary_percentage: null,
              calculation_days: 0,
              deduct_from: "0",
              leave_type_id: null,
              salary_deduct: "0",
              frequency: null,
              grace: null,
              leave_deduct: null,
              conversion_rules: [
                {
                  days: '',
                  deduct: ''
                }
              ],
              leave_deduction_layers: []
            },
            3: {
              type: "3",
              status: 0,
              factor: 0,
              salary_deduction_enabled: 0,
              salary_depends_on: "0",
              salary_percentage: null,
              calculation_days: 0,
              deduct_from: "0",
              leave_type_id: null,
              salary_deduct: "0",
              frequency: null,
              grace: null,
              leave_deduct: null,
              conversion_rules: [
                {
                  days: '',
                  deduct: ''
                }
              ],
              leave_deduction_layers: []
            }
          }
        },

        addedTypes: [],
        search: '',
        columns: columns,
        sortKey: 'type',
        sortOrders: sortOrders,
        length: 10,
        pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
        activityLogs: [],
        selectedLog: null,
        log_temp_length: 10,
        log_length_options: [
          { value: 10, text: "10" },
          { value: 20, text: "20" },
          { value: 50, text: "50" }
        ],
        log_pagination: { currentPage: 1 },

        status: [
          { value: null, text: "Select..." },
          { value: "1", text: "Enable" },
          { value: "0", text: "Disabled" },
        ],

        types: [
          { value: "0", text: "Absent" },
          { value: "1", text: "Late Clock In" },
          { value: "2", text: "Early Clock Out" },
          { value: "3", text: "Incomplete Hours" },
        ],

        deduct_from_options: [
          { value: "0", text: "Leave" },
          { value: "1", text: "Salary" }
        ],

        calculate_on_options: [
          { value: "0", text: "Basic" },
          { value: "1", text: "Gross" }
        ],

        leavetypes: [],

        selected_type: "0",
        modalTitle: 'Create Penalty Policy',
        tabRadioKey: 0,
      };
    },
    methods: {
      leaveLayerNames(type) {
        var names = [];
        var layers = this.fdata.policies[type].leave_deduction_layers || [];

        for (var i = 0; i < layers.length; i++) {
          var id = layers[i];

          for (var j = 0; j < this.leavetypes.length; j++) {
            if (this.leavetypes[j].value == id) {
              names.push(this.leavetypes[j].text);
            }
          }
        }

        return names.join(', ');
      },
      getTypeText(type) {
        let found = this.types.find((item) => item.value == type);

        if (found) {
          return found.text;
        }

        return '';
      },
      onTabChange(index) {
        if (this.tabs[index] !== undefined) {
          this.activeTab = index;
        }
      },
      changeTab(val) {
        if (this.selected_type === val) {
          return;
        }
        this.validateActiveTab().then(valid => {
          if (valid) {
            this.selected_type = val;
          } else {
            this.tabRadioKey++;
          }
        });
      },
      validateActiveTab() {
        let fields = this.getActiveTabFields();
        if (fields.length === 0) {
          return Promise.resolve(true);
        }
        let promises = fields.map(field => this.$validator.validate(field));
        return Promise.all(promises).then(results => {
          return results.every(res => res === true);
        });
      },
      getActiveTabFields() {
        let fields = [];
        let type = this.selected_type;
        let policy = this.fdata.policies[type];
        if (policy && policy.status == 1) {
          if (type != 3) {
            // Conversion rules
            if (policy.conversion_rules) {
              policy.conversion_rules.forEach((rule, idx) => {
                fields.push('days_' + idx);
                fields.push('deduct_' + idx);
              });
            }
            // Salary percentage
            if (policy.salary_deduction_enabled == 1) {
              fields.push('salary_percentage');
            }
          } else {
            // Incomplete hours tab fields
            if (policy.deduct_from == 0) {
              fields.push('leave_type_id');
            }
            fields.push('frequency');
            fields.push('grace');
            fields.push('leave_deduct');
          }
        }
        return fields;
      },
      closeTab(x) {
        this.fdata.policies[x].status = 0;
        let index = this.tabs.indexOf(x);

        if (index !== -1) {
          this.tabs.splice(index, 1);
        }

        let addedIndex = this.addedTypes.indexOf(x);

        if (addedIndex !== -1) {
          this.addedTypes.splice(addedIndex, 1);
        }

        if (this.activeTab >= this.tabs.length) {
          this.activeTab = this.tabs.length - 1;
        }

        if (this.activeTab < 0) {
          this.activeTab = 0;
        }
      },
      newTab(type) {
        this.fdata.policies[type].status = 1;
        if (!this.tabs.includes(type)) {
          this.tabs.push(type);
        }

        if (!this.addedTypes.includes(type)) {
          this.addedTypes.push(type);
        }

        this.activeTab = this.tabs.indexOf(type);
      },

      handleFactorChange(type) {
        let policy = this.fdata.policies[type];

        if (!policy) {
          return;
        }

        if (!Array.isArray(policy.conversion_rules)) {
          this.$set(policy, 'conversion_rules', []);
        }

        if (Number(policy.factor) === 1) {
          if (policy.conversion_rules.length === 0) {
            policy.conversion_rules.push({
              days: '',
              deduct: ''
            });
          }

          if (policy.conversion_rules.length > 1) {
            policy.conversion_rules = [policy.conversion_rules[0]];
          }
        }

        if (Number(policy.factor) === 0) {
          if (policy.conversion_rules.length === 0) {
            policy.conversion_rules.push({
              days: '',
              deduct: ''
            });
          }
        }
      },

      addConversionRule(type) {
        let policy = this.fdata.policies[type];

        if (!policy) {
          return;
        }

        if (Number(policy.factor) === 1) {
          if (!Array.isArray(policy.conversion_rules) || policy.conversion_rules.length === 0) {
            this.$set(policy, 'conversion_rules', [
              {
                days: '',
                deduct: ''
              }
            ]);
          }

          if (policy.conversion_rules.length > 1) {
            policy.conversion_rules = [policy.conversion_rules[0]];
          }

          return;
        }

        policy.conversion_rules.push({
          days: '',
          deduct: ''
        });
      },
      makeEmptyForm() {
        return {
          id: '',
          name: '',
          policies: {
            0: {
              type: "0",
              status: 0,
              factor: 0,
              salary_deduction_enabled: 0,
              salary_depends_on: "0",
              salary_percentage: null,
              calculation_days: 0,
              deduct_from: "0",
              leave_type_id: null,
              salary_deduct: "0",
              frequency: null,
              grace: null,
              leave_deduct: null,
              conversion_rules: [
                {
                  days: '',
                  deduct: ''
                }
              ],
              leave_deduction_layers: []
            },
            1: {
              type: "1",
              status: 0,
              factor: 0,
              salary_deduction_enabled: 0,
              salary_depends_on: "0",
              salary_percentage: null,
              calculation_days: 0,
              deduct_from: "0",
              leave_type_id: null,
              salary_deduct: "0",
              frequency: null,
              grace: null,
              leave_deduct: null,
              conversion_rules: [
                {
                  days: '',
                  deduct: ''
                }
              ],
              leave_deduction_layers: []
            },
            2: {
              type: "2",
              status: 0,
              factor: 0,
              salary_deduction_enabled: 0,
              salary_depends_on: "0",
              salary_percentage: null,
              calculation_days: 0,
              deduct_from: "0",
              leave_type_id: null,
              salary_deduct: "0",
              frequency: null,
              grace: null,
              leave_deduct: null,
              conversion_rules: [
                {
                  days: '',
                  deduct: ''
                }
              ],
              leave_deduction_layers: []
            },
            3: {
              type: "3",
              status: 0,
              factor: 0,
              salary_deduction_enabled: 0,
              salary_depends_on: "0",
              salary_percentage: null,
              calculation_days: 0,
              deduct_from: "0",
              leave_type_id: null,
              salary_deduct: "0",
              frequency: null,
              grace: null,
              leave_deduct: null,
              conversion_rules: [
                {
                  days: '',
                  deduct: ''
                }
              ],
              leave_deduction_layers: []
            }
          }
        };
      },
      removeConversionRule(type, idx) {
        this.fdata.policies[type].conversion_rules.splice(idx, 1);

        if (this.fdata.policies[type].conversion_rules.length === 0) {
          this.fdata.policies[type].conversion_rules.push({
            days: '',
            deduct: ''
          });
        }
      },
      availableLeaveTypes(type, idx) {
        var selected = [];
        var layers = this.fdata.policies[type].leave_deduction_layers || [];

        for (var i = 0; i < layers.length; i++) {
          if (i != idx && layers[i] != null) {
            selected.push(layers[i]);
          }
        }

        return this.leavetypes.filter(function(opt) {
          return selected.indexOf(opt.value) == -1;
        });
      },
      addLeaveLayer(type) {
        let layers = this.fdata.policies[type].leave_deduction_layers;

        if (!Array.isArray(layers)) {
          this.$set(this.fdata.policies[type], 'leave_deduction_layers', []);
          layers = this.fdata.policies[type].leave_deduction_layers;
        }

        let hasEmpty = layers.some(function(item) {
          return item === null || item === '' || item === undefined;
        });

        if (hasEmpty) {
          return;
        }

        layers.push(null);
      },
      removeLeaveLayer(type, idx) {
        this.fdata.policies[type].leave_deduction_layers.splice(idx, 1);
      },

        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
      resetForm() {
        this.fdata = this.makeEmptyForm();
        this.tabs = [0,1,2,3];
        this.addedTypes = [];
        this.activeTab = 0;
        this.selected_type = "0";
        this.tabRadioKey = 0;

        this.$nextTick(() => {
          this.$validator.reset();
        });
      },
        addNew() {
            this.modalTitle = 'Create Penalty Policy';
            this.resetForm();
            this.$bvModal.show('bv-modal-penalty-policy');
        },

        getLeaveTypes: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/leave-attendance/leave/type/list').then(function (response) {
                this.leavetypes = response.data;
            }.bind(this)).catch(function (error) {
                currentObj.serverError(error);
            });
        },


        getData: function () {
            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/leave-attendance/penalty/policy/index').then((response) => {
              this.datalist = response.data;
            }).catch((error) => {
              this.serverError(error);
            });
        },
      editData(x) {
        if (!this.checkNet()) return false;

        this.showoverlay = true;

        axios.get('/leave-attendance/penalty/policy/show/' + x).then((response) => {
          this.resetForm();
          this.tabs = [0,1,2,3];
          this.activeTab = 0;
          let resdata = response.data;
          for(let [k,v] of Object.entries(resdata.policies)){
            v.factor = Number(v.factor || 0);
            v.calculation_days = Number(v.calculation_days || 0);
            this.addedTypes.push(k);

            if (typeof v.leave_deduction_layers == 'string') {
              try {
                v.leave_deduction_layers = JSON.parse(v.leave_deduction_layers);
              } catch (e) {
                v.leave_deduction_layers = [];
              }
            }

            if (!Array.isArray(v.leave_deduction_layers)) {
              v.leave_deduction_layers = [];
            }

            if (typeof v.conversion_rules == 'string') {
              try {
                v.conversion_rules = JSON.parse(v.conversion_rules);
              } catch (e) {
                v.conversion_rules = [
                  {
                    days: '',
                    deduct: ''
                  }
                ];
              }
            }

            if (!Array.isArray(v.conversion_rules) || v.conversion_rules.length === 0) {
              v.conversion_rules = [
                {
                  days: '',
                  deduct: ''
                }
              ];
            }

            if (Number(v.factor) == 1 && v.conversion_rules.length > 1) {
              v.conversion_rules = [v.conversion_rules[0]];
            }
          }

          for(let val of ["0", "1", "2", "3"]) {
            if(!this.addedTypes.includes(val)) {
              resdata.policies[val] = {
                type: String(val),
                status: 0,
                factor: 0,
                salary_deduction_enabled: 0,
                salary_depends_on: "0",
                salary_percentage: null,
                calculation_days: 0,
                deduct_from: "0",
                leave_type_id: null,
                salary_deduct: "0",
                frequency: null,
                grace: null,
                leave_deduct: null,
                conversion_rules: [
                  {
                    days: '',
                    deduct: ''
                  }
                ],
                leave_deduction_layers: []
              };
            }
          }

          this.fdata = resdata;

          let firstActive = ["0", "1", "2", "3"].find(val => resdata.policies[val] && resdata.policies[val].status == 1);
          this.selected_type = firstActive || "0";

          this.modalTitle = 'Edit Penalty Policy';
          this.$bvModal.show('bv-modal-penalty-policy');
          this.showoverlay = false;
        }).catch((error) => {
          this.showoverlay = false;
          this.serverError(error);
        });
      },
      deleteData(x) {
        if (!this.checkNet()) return false;

        this.$bvModal.msgBoxConfirm(
          'Are you sure you want to delete this penalty policy?',
          {
            title: 'Confirm Deletion',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'primary',
            okTitle: 'Yes',
            cancelTitle: 'No',
            footerClass: 'p-2',
            centered: true
          }
        ).then(confirmed => {
          if (!confirmed) return;

          this.showoverlay = true;

          let formData = new FormData();
          formData.append('id', x);
          axios.post(this.$api_url + '/leave-attendance/penalty/policy/delete', formData).then((response) => {
            this.$bvToast.toast('Deleted Successfully', {
              solid: true,
              variant: 'success',
              title: 'Success'
            })
            this.getData();
            this.getActivityLogs();
            this.showoverlay = false;
          }).catch((error) => {
            this.showoverlay = false;
            this.serverError(error);
          });
        });
      },

      onSubmit(e) {
        if (!this.checkNet()) return false;

        this.$validator.validateAll().then(result => {
          if (!result) {
            return;
          }

          this.showoverlay = true;
          e.preventDefault();

          let formData = new FormData();
          let policies = {};

          for (let [k,v] of Object.entries(this.fdata.policies)) {
            if(v.status == 1) {
              policies[k] = v;
            }
          }

          if(this.fdata.id != '') {
            formData.append('id', this.fdata.id);
          }
          formData.append('name', this.fdata.name);
          formData.append('policies', JSON.stringify(policies));

          axios.post(this.$api_url + '/leave-attendance/penalty/policy/save', formData).then((response) => {
            this.getData();
            this.getActivityLogs();
            this.$bvToast.toast(response.data.message, {
              title: `Success`,
              variant: 'success',
              solid: true
            });
            this.showoverlay = false;
            this.resetForm();
            this.$bvModal.hide('bv-modal-penalty-policy');
          }).catch((error) => {
            this.showoverlay = false;
            this.serverError(error);
          });
        });
      },

      getActivityLogs() {
        axios.get(this.$api_url + '/leave-attendance/penalty/policy/activity-log').then((response) => {
          this.activityLogs = response.data;
        }).catch((error) => {
          this.serverError(error);
        });
      },
      viewLogDetails(log) {
        this.selectedLog = log;
        this.$bvModal.show('bv-modal-log-details');
      },
      getLeaveLayerNamesForLog(layers) {
        if (!Array.isArray(layers)) return '';
        var names = [];
        for (var i = 0; i < layers.length; i++) {
          var id = layers[i];
          for (var j = 0; j < this.leavetypes.length; j++) {
            if (this.leavetypes[j].value == id) {
              names.push(this.leavetypes[j].text);
            }
          }
        }
        return names.join(' -> ');
      },
      getConversionDaysLabelText(type) {
        var t = parseInt(type);
        if (t == 0) return 'absent days';
        if (t == 1) return 'late clock ins';
        if (t == 2) return 'early outs';
        if (t == 3) return 'incomplete days';
        return 'days';
      },
      formatDateTime(str) {
        if (!str) return '';

        const d = new Date(str);
        const pad = value => String(value).padStart(2, '0');

        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
      },

    },
    created: function () {
        this.getLeaveTypes();
        this.getData();
        this.getActivityLogs();
    },

    computed:
    {
      parsedDetails() {
        if (!this.selectedLog || !this.selectedLog.details) return null;
        try {
          const parsed = typeof this.selectedLog.details === 'string'
            ? JSON.parse(this.selectedLog.details)
            : this.selectedLog.details;
          return parsed.policies || parsed;
        } catch (e) {
          return null;
        }
      },
      paginatedLogs() {
        if (!Array.isArray(this.activityLogs)) return [];
        const start = (this.log_pagination.currentPage - 1) * this.log_temp_length;
        const end = start + this.log_temp_length;
        return this.activityLogs.slice(start, end);
      },
      penaltyTypeDescription() {
        if (this.tabs.length === 0) {
          return '';
        }

        var t = parseInt(this.selected_type);

        if (t == 0) return 'Configure how absents are converted to absent days and what actions to take.';
        if (t == 1) return 'Configure how late clock ins are converted to absent days and what actions to take.';
        if (t == 2) return 'Configure how early clock outs are converted to absent days and what actions to take.';
        if (t == 3) return 'Configure how incomplete hours are converted to absent days and what actions to take.';
        return '';
      },

      conversionDaysLabel() {
        var t = parseInt(this.selected_type);

        if (t == 0) return 'Absent Days';
        if (t == 1) return 'Late Clock In (Days)';
        if (t == 2) return 'Early Out (Days)';
        if (t == 3) return 'Incomplete Days';
        return 'Days';
      },
        filteredData()
        {
            let filtered_list = this.datalist;
            if (this.search)
            {
                filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
            }
            return filtered_list;
        },
        paginatedData()
        {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        }
    }
}
</script>
